/** A failure in the reader's terms, with a way out. Never a stack trace. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import { Button } from "../Button/Button";
import "./ErrorState.css";

export interface ErrorStateProps {
  readonly headline: ReactNode;
  readonly body?: ReactNode;
  readonly onRetry?: () => void;
  readonly retryLabel?: string;
  readonly secondaryAction?: ReactNode;
  /** The machine-readable code off the error body, for support. */
  readonly code?: string;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function ErrorState({
  headline,
  body,
  onRetry,
  retryLabel = "Retry",
  secondaryAction,
  code,
  className,
  style,
}: ErrorStateProps) {
  return (
    <div role="alert" className={cn("al-errorstate", className)} style={style}>
      <div className="al-errorstate-headline">{headline}</div>
      {body !== undefined ? <div className="al-errorstate-body">{body}</div> : null}
      {onRetry !== undefined || secondaryAction !== undefined ? (
        <div className="al-errorstate-actions">
          {onRetry !== undefined ? (
            <Button variant="primary" size="sm" onClick={onRetry}>
              {retryLabel}
            </Button>
          ) : null}
          {secondaryAction}
        </div>
      ) : null}
      {code !== undefined ? <div className="al-errorstate-code al-mono">{code}</div> : null}
    </div>
  );
}
